import GroupIcon from "../images/GroupIcon.mjs";

/**
 * App icon for users or groups of users
 * @see {GlyphIcon}
 * @see {GroupIcon}
 */
const AppUsersIcon = class extends GroupIcon {};

export default AppUsersIcon;